import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RefferalsOptyCountGraph = ({ refferalsOptyGraph }) => {
  const { labels, values } = useMemo(() => {
    if (!Array.isArray(refferalsOptyGraph) || refferalsOptyGraph.length === 0) {
      return { labels: [], values: [] };
    }

    // Filter out invalid objects AND empty objects
    const validData = refferalsOptyGraph.filter(
      item => item && typeof item === 'object' && Object.keys(item).length > 0
    );

    if (validData.length === 0) {
      return { labels: [], values: [] };
    }

    const safeLabels = validData.map((item, idx) =>
      item && typeof item.key === "string" ? item.key : `Unknown ${idx + 1}`
    );

    const safeValues = validData.map((item) =>
      Number(item?.OPTY_ID?.value ?? 0)
    );

    return { labels: safeLabels, values: safeValues };
  }, [refferalsOptyGraph]);

  if (!labels.length || !values.length) {
    return <div className="text-center text-gray-500">No data available</div>;
  }

  const data = {
    labels,
    datasets: [
      {
        label: "OPTY ID Value",
        data: values,
        backgroundColor: "rgba(135, 206, 250, 0.8)",
        borderColor: "rgba(135, 206, 250, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: { display: true, text: "Referrals Opportunity Count", font: { size: 16 } },
      legend: { display: true, position: "top" },
      tooltip: { callbacks: { label: (ctx) => `Value: ${ctx.raw}` } },
    },
    scales: {
      y: {
        beginAtZero: true,
        suggestedMax: Math.max(...values, 0) + 1,
        grid: { display: false },
        ticks: { precision: 0 },
      },
      x: {
        grid: { display: false },
        ticks: { autoSkip: false, maxRotation: 45, minRotation: 0 },
      },
    },
  };

  return (
    <div style={{ height: "300px", width: "500px" }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default RefferalsOptyCountGraph;